export const initialState = {
  guestToken: '',
  exp: 0
};
